import { TYPES_SOURCE_OPTIONS } from '@constants'

export const isSystemSource = (source: string | undefined) => {
  return source === TYPES_SOURCE_OPTIONS.SYSTEM
}
